import angular from 'angular';

class ContentLayoutCtrl {
    /*@ngInject*/
    constructor($rootScope, $state, $translate, logger) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$translate = $translate;
        this.logger = logger;
    }

    $onInit() {
        let vm = this;

        vm.$rootScope.$watch(function () {
            return vm.$state.current;
        }, setTitle);

        function setTitle() {
            vm.title = '';
            if (vm.$state && vm.$state.current) {
                switch (vm.$state.current.name) {
                    case 'app.admin.metrics':
                        vm.title =
                            vm.$translate.instant('metrics.title') +
                            ' ' +
                            getAppDisplayName(vm.$state.params.application);
                        break;
                    case 'app.admin.monitoring':
                        vm.title = vm.$translate.instant('monitoring.title.' + vm.$state.params.application);
                        break;
                    case 'app.admin.periodictasks':
                        vm.title = vm.$translate.instant('perioic_tasks.title');
                        break;
                    case 'app.admin.audit':
                        vm.title =
                            vm.$translate.instant('audit.title') +
                            ' ' +
                            getAppDisplayName(vm.$state.params.application);
                        break;
                    case 'app.invitedentity.list':
                        vm.title = vm.$translate.instant('kiss_invited_entity.list.title');
                        break;
                    case 'app.kissseller.list':
                        vm.title = vm.$translate.instant('kiss_seller.list.title');
                        break;
                    case 'app.invitedentity.sellerrelations':
                        vm.title = vm.$translate.instant('invited_entity_relation.list.title');
                        break;
                    case 'app.kissuser.list':
                        vm.title = vm.$translate.instant('kiss_user.list.title');
                        break;
                    case 'app.kissinvoice.list':
                        vm.title = vm.$translate.instant('kiss_invoice.list.title');
                        break;
                    case 'app.kissorder.list':
                        vm.title = vm.$translate.instant('kiss_order.list.title');
                        break;
                    case 'app.prepasrel.list-workflows':
                        vm.title = vm.$translate.instant('prepasrel.workflow.list.title');
                        break;
                    case 'app.docrepoinvoice.list':
                        vm.title = vm.$translate.instant('docrepo_invoice.list.title');
                        break;
                    case 'community.list.main':
                        vm.title = vm.$translate.instant('community.list.title');
                        break;
                    case 'app.payment.list':
                        vm.title = vm.$translate.instant('payment.list.title');
                        break;
                    default:
                        break;
                }
            }
        }

        function getAppDisplayName(application) {
            var appDisplayName = '';
            switch (application) {
                case 'kiss':
                    appDisplayName = 'Kiss';
                    break;
                case 'epdf':
                    appDisplayName = 'ePdf';
                    break;
                case 'zedoc':
                    appDisplayName = 'ZeDoc';
                    break;
                default:
                    vm.logger.error('l\'application "' + application + '" est inconnue');
                    break;
            }
            return appDisplayName;
        }
    }
}

angular.module('app').component('contentLayout', {
    templateUrl: require('./content-layout.html'),
    controller: ContentLayoutCtrl,
});
